// import { List } from 'react-admin';

import TaskListContent from './TaskListContent';

const TaskList = () => {
    const tasks = [
        { id: 1, index: 0, description: 'Lorem ipsum', user_ids: [1, 3], notes: 'Lorem ipsum dolor sit amet', status: 'new' },
        { id: 2, index: 0, description: 'Lorem', user_ids: [2], notes: 'Lorem ipsum dolor sit amet', status: 'done' },
        { id: 3, index: 0, description: 'Ipsum', user_ids: [5], notes: 'Lorem ipsum dolor sit amet', status: 'in_progress' },
        { id: 4, index: 0, description: 'Lorem ipsum', user_ids: [7], notes: null, status: 'new' },
    ];

    return (
        // <List
        //     resource="tasks"
        //     perPage={100}
        //     sort={{ field: 'index', order: 'ASC' }}
        //     pagination={false}
        //     component="div"
        // >
        <TaskListContent data={tasks} />
        // </List>
    );
};

export default TaskList;